import React, { Fragment, useEffect } from 'react';
import { apiService } from 'services/base.service';
import useDashboardContext from 'contexts/dashboard.context';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import useBrandContext from 'contexts/brand.context';
import { BrandType } from 'utils/types';
import RightSidebar from 'components/right-sidebar';
import { ReactComponent as BrandDetailsIcon } from 'assets/icons/brand-details.svg';
import { ReactComponent as OpeningTimeIcon } from 'assets/icons/opening-time.svg';
import { ReactComponent as MetadataIcon } from 'assets/icons/metadata.svg';
import { isFCBBrand } from 'utils/functions';

const BrandContent = () => {
  const { brand_id } = useParams();
  const navigate = useNavigate();

  const { setRightSection, category } = useDashboardContext();
  const { createBrandForm, setActiveBrand, setBrandWorkingHours } = useBrandContext();
  if (!brand_id) {
    navigate(-1);
    return null;
  }

  const BrandDetailsNav = [
    {
      title: 'Brand details',
      link: `brand/${brand_id}/details`,
      Icon: BrandDetailsIcon
    },
    ...(createBrandForm.preorder || !isFCBBrand(createBrandForm.brand_type)
      ? [
          {
            title: 'Brand opening time',
            link: `brand/${brand_id}/opening-time`,
            Icon: OpeningTimeIcon
          }
        ]
      : []),
    {
      title: 'Brand metadata',
      link: `brand/${brand_id}/metadata`,
      Icon: MetadataIcon
    },
    {
      title: 'Brand polygon',
      link: `brand/${brand_id}/polygon`,
      Icon: MetadataIcon
    }
  ];
  useEffect(() => {
    getBrandDetails();
    getBrandWorkingHours();
  }, [brand_id]);

  useEffect(() => {
    setRightSection(<RightSidebar list={BrandDetailsNav} />);

    return () => {
      setRightSection(null);
    };
  }, [createBrandForm.preorder, createBrandForm.brand_type]);

  const getBrandDetails = async () => {
    if (!category) return;
    try {
      const res: any = await apiService.get(`brand_management/brands/${brand_id}`);
      setActiveBrand(res?.data?.data);
    } catch {
      setActiveBrand({} as BrandType);
    }
  };
  const getBrandWorkingHours = async () => {
    try {
      const res: any = await apiService.get(`marketing/brand/working-hours/${brand_id}`, {
        isInternal: true
      });
      setBrandWorkingHours(res?.data?.data);
    } catch {
      setActiveBrand({} as BrandType);
    }
  };
  return (
    <Fragment>
      <Outlet />
    </Fragment>
  );
};

export default BrandContent;
